import React from "react";
import ReactDOM from "react-dom/client";
import { SnackbarProvider, useSnackbar } from "notistack";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { setSnackbarRef } from "src/utils/shared/snackbarUtils";
import App from "./App";
import "./index.css";

const SnackbarUtilsConfigurator: React.FC = () => {
  setSnackbarRef(useSnackbar());
  return null;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SnackbarProvider maxSnack={3}>
        <SnackbarUtilsConfigurator />
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </SnackbarProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
